// import React, { useEffect, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { DateFormat } from '../utils';
import { toast } from 'react-toastify';

const Calendar = ({data}) =>
{
	const events = data && data.length ? data : [];
	const ShowEventInfo = (info) =>
	{
		toast.info(<div className='text-sm'>
			<div><span className='font-bold'>{info.event.title}</span></div>
			<div className='flex justify-between mt-2 pe-3'><span>مرتبط با: </span><span>{info.event.extendedProps.related_to}</span></div>
			<div className='flex justify-between mt-2 pe-3'><span>زمان: </span><span dir='ltr'>{DateFormat(info.event.start)}</span></div>
		</div>);
	}

	return <FullCalendar
		plugins={[timeGridPlugin, dayGridPlugin]}
		initialView='timeGridWeek'
		events={events}
		locale={'fa'}
		direction='rtl'
		firstDay={6}
		headerToolbar= {{left:'prev,next today', center:'title', right:'timeGridWeek,dayGridMonth'}}
		buttonText={{today: 'امروز', month: 'ماهانه', week: 'هفتگی', day: 'روزانه', list: 'لیست'}}
		allDaySlot={false}
		slotMinTime='07:00:00'
		slotMaxTime='21:00:00'
		contentHeight='auto'
		dayMaxEvents={3}
		moreLinkText='نمایش همه'
		eventClick={(info) => ShowEventInfo(info)}
		businessHours= {{
			daysOfWeek: [ 0, 1, 2, 3, 4, 6],
			startTime: '00:00',
			endTime: '24:00',
		}}
	/>
};

export default Calendar;